import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import TeacherCard from './TeacherCard';
import '../../../assets/css/teacherMaster.css';
import { useNavigate } from 'react-router-dom';
import { FilterMatchMode } from 'primereact/api';
import AddTeacherMasterDialog from './AddTeacherMaster';
import { Dialog } from 'primereact/dialog';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Toast from '../../Shared/Toast/Toast';
import DeleteConfirmation from '../../Dialogs/DeleteConfirmation';
import { InputSwitch } from 'primereact/inputswitch';
import ResetPassword from '../../ResetPassword/ResetPassword';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import { FileUpload } from "primereact/fileupload";
import { Tooltip } from 'primereact/tooltip';
import { Tag } from 'primereact/tag';
import { apiBase } from '../../../utils/config';

const TeacherMaster = () => {
    const { catchResponse } = useCatchResponse();
    const navigate = useNavigate();
    const [securityUserID, setSecurityUserID] = useState("");
    const [sortOption, setSortOption] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [visible, setVisible] = useState(false);
    const [viewMode, setViewMode] = useState('card');
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        Name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        Phone: { value: null, matchMode: FilterMatchMode.CONTAINS },
        Email: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);
    const [deleteId, setDeleteId] = useState('');
    const [teachersList, setTeachersList] = useState([]);
    const [updatedStatus, setUpdatedStatus] = useState('');
    const [isStatusConfirmation, setIsStatusConfirmation] = useState(false);
    const [updatedPassword, setUpdatedPassword] = useState('');
    const [isPasswordReset, setIsPasswordReset] = useState(false);
    const [accessList, setAccessList] = useState({});
    const fileUploadRef = useRef(null);
    const [isUploadVisible, setIsUploadVisible] = useState(false);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        GetTeachersList(loginData?._id);
        GetConfigurationData(loginData?._id);
    }, []);

    const GetConfigurationData = async (id) => {
        try {
            let data = {
                id: id,
            }
            await api.post(APIConstant.path.GetPasswordConfigurationDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    setAccessList(res?.data);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const onCancel = () => {
        setVisible(false);
        GetTeachersList(securityUserID);
    }

    const toggleActiveStatus = (id, status) => {
        setDeleteId(id);
        setUpdatedStatus(status === true ? 'Active' : 'Inactive');
        setIsStatusConfirmation(true);
    };

    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };

    const GetTeachersList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            Loader.show();
            await api.post(APIConstant.path.getTeacherDetailList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setTeachersList(res.data);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            Loader.hide();
            console.log(err);
            catchResponse(err);
        }
    }

    const actionBodyTemplate = (rows) => {
        return (
            <React.Fragment>
                <div className='p-d-flex p-ai-center'>
                    <Button icon="pi pi-pencil" className="e-sction-btn p-m-0" onClick={() => {
                        navigate('/viewEdit-teacher-master', { state: { userId: rows?._id, isEdit: true } })
                    }} />
                    <Button icon="pi pi-trash" className="e-sction-btn p-m-0 p-m-2" onClick={(e) => {
                        setIsDeleteConfirmation(true);
                        setDeleteId(rows._id);
                    }} />
                    <InputSwitch
                        checked={rows?.Status === 'Active' ? true : false}
                        onChange={(e) => {
                            toggleActiveStatus(rows._id, e.value);
                        }}
                        className="p-ml-2 p-mt-1"
                    />
                    {rows?.Phone && accessList?.IsTeacher &&
                        <Button icon="pi pi-key" className="e-sction-btn p-m-0 p-m-2" onClick={(e) => {
                            setIsPasswordReset(true);
                            setDeleteId(rows._id);
                        }} />}
                </div>
            </React.Fragment>
        );
    };

    const actionBodyTemplateSrNo = (data, props) => {
        return props.rowIndex + 1;
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={(e) => DeleteTeacher()}
            />
        </div>
    );

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };

    const handleResetClose = () => {
        setIsPasswordReset(false)
    };

    const handleDelete = (id) => {
        setIsDeleteConfirmation(true);
        setDeleteId(id);
    };

    const handleResetPassword = (id) => {
        setIsPasswordReset(true);
        setDeleteId(id);
    };

    const renderStatusFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleCloseStatus}
            />
            <Button
                label="Save"
                className="btn-text-action-primary"
                onClick={(e) => UpdateStatus()}
            />
        </div>
    );

    const renderResetFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleResetClose}
            />
            <Button
                label="Save"
                className="btn-text-action-primary"
                onClick={(e) => UpdatePassword()}
            />
        </div>
    );

    const handleCloseStatus = () => {
        setIsStatusConfirmation(false)
    };

    const handlePasswordChange = (password) => {
        setUpdatedPassword(password);
    };

    const UpdateStatus = async () => {
        try {
            let data = {
                id: deleteId,
                Status: updatedStatus
            }
            await api.post(APIConstant.path.updateTeacherStatus, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: 'Teacher status updated successfully' });
                    setDeleteId('');
                    setUpdatedStatus('');
                    GetTeachersList(securityUserID);
                }
                handleCloseStatus();
            }).catch(err => {
                Loader.hide();
                setDeleteId('');
                setUpdatedStatus('');
                handleCloseStatus();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const UpdatePassword = async () => {
        try {
            let data = {
                id: deleteId,
                Password: updatedPassword
            }
            await api.post(APIConstant.path.updatePassword, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: 'Teacher password updated successfully' });
                    setDeleteId('');
                    setUpdatedPassword('');
                    await GetTeachersList(securityUserID);
                }
                handleResetClose();
            }).catch(err => {
                Loader.hide();
                Toast.error({ message: err?.message });
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const DeleteTeacher = async () => {
        try {
            let data = {
                id: deleteId
            }
            await api.post(APIConstant.path.deleteTeacher, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: 'Teacher deleted successfully' });
                    setDeleteId('');
                    setUpdatedStatus('');
                    GetTeachersList(securityUserID);
                }
                handleClose();
            }).catch(err => {
                Loader.hide();
                setDeleteId('');
                setUpdatedStatus('');
                handleClose();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const handleDownloadSampleFile = async () => {
        try {
            Loader.show();
            const loginData = CommonConfig.loginData();
            const payload = {
                accountType: loginData?.AccountType,
                userType: loginData?.UserType,
                userId: loginData?.UserRole === 'Teacher' ? loginData?.CreatedBy : securityUserID,
            };
            const res = await api.post(APIConstant.path.GenerateTeacherSample, payload);
            if (res.success && res?.sampleFileUrl) {
                const downloadUrl = `${apiBase}${res.sampleFileUrl}`;
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("download", downloadUrl.split('/').pop());
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                Loader.hide();
            } else {
                Loader.hide();
                Toast.error({ message: res?.message || 'Failed to download sample file' });
            }
        } catch (err) {
            Loader.hide();
            Toast.error({ message: err?.message || 'Failed to download sample file' });
            catchResponse(err);
        }
    };

    const handleUploadVisible = () => {
        setIsUploadVisible(false)
    };

    const headerTemplate = (options) => {
        const { className, chooseButton, uploadButton, cancelButton } = options;
        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                {chooseButton}
                {uploadButton}
                {cancelButton}
            </div>
        );
    };

    const itemTemplate = (file, props) => {
        return (
            <div className="">
                <div className="p-d-flex p-ai-baseline p-jc-between">
                    <div className="flex flex-column text-left ml-3">
                        <p> {file.name} </p>
                        <small>{new Date().toLocaleDateString()}</small>
                    </div>
                </div>
                <Tag value={props.formatSize} severity="warning" className="e-uplod-box" />
                <div className='p-d-flex p-ai-center p-jc-center'>
                    <Button type="button" icon="pi pi-times" className="p-d-flex p-ai-center p-jc-center p-button-outlined p-button-rounded p-button-danger ml-auto p-m-0" onClick={() => onTemplateRemove(file, props.onRemove)} />
                </div>
            </div>
        );
    };

    const emptyTemplate = () => {
        return (
            <div className="flex align-items-center flex-column">
                <i className="pi pi-image mt-3 p-5" style={{ fontSize: '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)' }}></i>
                <span style={{ fontSize: '1.2em', color: 'var(--text-color-secondary)' }} className="my-5">
                    Drag and Drop Image Here
                </span>
            </div>
        );
    };

    const onTemplateUpload = async (e) => {
        const uploadedFile = e.files[0];
        if (!uploadedFile) return;

        try {
            Loader.show();
            const loginData = CommonConfig.loginData();
            const formData = new FormData();
            formData.append("file", uploadedFile);
            formData.append("filename", uploadedFile?.name);
            formData.append("accountType", loginData?.AccountType);
            formData.append("userType", loginData?.UserType);
            formData.append("userId", loginData?.UserRole === 'Teacher' ? loginData?.CreatedBy : securityUserID);
            await api.post(APIConstant.path.ImportTeachers, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then(async (response) => {
                    let res = response;
                    if (res.success) {
                        Loader.hide();
                        if (res?.skippedFileUrl) {
                            var downloadUrl = `${apiBase}${res?.skippedFileUrl}`;
                            const link = document.createElement("a");
                            link.href = downloadUrl;
                            link.setAttribute("download", downloadUrl.split('/').pop());
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        }
                        handleUploadVisible();
                        Toast.success({ message: res?.message });
                        await GetTeachersList(securityUserID);
                    } else {
                        Loader.hide();
                        if (res?.skippedFileUrl) {
                            var downloadcatchUrl = `${apiBase}${res?.skippedFileUrl}`;
                            const link = document.createElement("a");
                            link.href = downloadcatchUrl;
                            link.setAttribute("download", downloadcatchUrl.split('/').pop());
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        }
                        Toast.error({ message: res.message });
                    }
                })
                .catch((err) => {
                    console.error(err);
                    Toast.error({ message: err?.message });
                    Loader.hide();
                });

        } catch (error) {
            Loader.hide();
            const errorMessage = error.response?.data?.message || "File upload failed.";
            Toast.error({ message: errorMessage });
            catchResponse(error);
        }
    };

    const onTemplateRemove = (file, callback) => {
        callback();
    };

    const chooseOptions = { icon: 'pi pi-fw pi-images', iconOnly: true, className: 'p-d-flex p-ai-center p-jc-center p-button-rounded p-button-outlined p-m-0' };
    const uploadOptions = { icon: 'pi pi-fw pi-cloud-upload', iconOnly: true, className: 'p-d-flex p-ai-center p-jc-center p-button-success p-button-rounded p-button-outlined p-m-0' };
    const cancelOptions = { icon: 'pi pi-fw pi-times', iconOnly: true, className: 'p-d-flex p-ai-center p-jc-center p-button-danger p-button-rounded p-button-outlined p-m-0' };

    return (
        <div className='wayment-owner-dashboard et-master-page'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-user-edit"></i>
                    <h2>Teacher Master</h2>
                </div>
                <div className="p-d-flex p-ai-center p-jc-between">
                    <div className="searchbar-area">
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Global Search" />
                        </span>
                    </div>
                    <Button icon="pi pi-download" onClick={handleDownloadSampleFile} className="e-h-btn" />
                    <Button icon="pi pi-upload" className="e-h-btn p-ml-2" onClick={() => setIsUploadVisible(true)} />
                    <Button icon="pi pi-plus" className="e-h-btn p-ml-2" onClick={() => setVisible(true)} />
                    <Button
                        icon={viewMode === 'card' ? 'pi pi-bars' : 'pi pi-th-large'}
                        className="e-h-btn p-ml-2"
                        onClick={() => setViewMode(viewMode === 'card' ? 'list' : 'card')}
                    />
                </div>
            </div>
            <div className={viewMode === 'card' ? 'teacher-grid' : 'teacher-list'}>
                {viewMode === 'card' ? (
                    teachersList.filter(x => x?.Name?.toLowerCase()?.includes(globalFilterValue.toLowerCase()) || x?.Email?.includes(globalFilterValue) || x?.Phone?.includes(globalFilterValue)).map(teacher => (
                        <TeacherCard key={teacher._id} teacher={teacher} handleDelete={handleDelete} toggleActiveStatus={toggleActiveStatus} handlePassword={handleResetPassword} AccessList={accessList} />
                    ))
                ) : (
                    <DataTable
                        value={teachersList}
                        paginator
                        rows={rows}
                        first={first}
                        filters={filters}
                        filterDisplay="menu"
                        globalFilterFields={['TeacherId', 'Name', 'Phone', 'Email', 'StudentListCount', 'TotalCapacity']}
                        responsiveLayout="scroll"
                        paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                        rowsPerPageOptions={[5, 10, 20]}
                        currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
                        onPage={onPageChange}
                        className='custom-table'
                        scrollHeight='calc(100vh - 120px)'
                        size='small'
                    >
                        <Column field="id" body={actionBodyTemplateSrNo} header="Sr No." style={{ width: '20%' }} />
                        <Column
                            field="TeacherId"
                            header="Teacher Id"
                            style={{ width: '20%' }}
                        />
                        <Column
                            field="Name"
                            header="Name"
                            style={{ width: '20%' }}
                        />
                        <Column
                            field="Phone"
                            header="Phone"
                            style={{ width: '20%' }}
                        />
                        <Column
                            field="Email"
                            header="Email"
                            style={{ width: '20%' }}
                        />
                        <Column body={actionBodyTemplate} header="Action" headerClassName='e-template-action' bodyClassName='e-template-action' headerStyle={{ width: '100%' }} />
                    </DataTable>
                )}
            </div>
            <Dialog
                header="Add Teacher Master"
                className='dialog-popup'
                visible={visible}
                onHide={() => onCancel()}
                draggable={false}
                position="center"
                style={{ width: '60vw' }}
            >
                <AddTeacherMasterDialog onCancel={onCancel} />

            </Dialog>
            <Dialog
                visible={isPasswordReset}
                onHide={handleResetClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Reset Password</span>
                    </div>
                }
                footer={renderResetFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <ResetPassword onPasswordChange={handlePasswordChange} />
            </Dialog>
            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Confirmation</span>
                    </div>
                }
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>
            <Dialog
                visible={isStatusConfirmation}
                onHide={handleCloseStatus}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Status Update</span>
                    </div>
                }
                footer={renderStatusFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <div>
                    <p>
                        Are you sure you want to update status?
                    </p>
                </div>
            </Dialog>
            <Dialog
                visible={isUploadVisible}
                onHide={handleUploadVisible}
                header="Upload Excel"
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '500px', minHeight: '480px', maxHeight: '480px', }}
            >
                <div>
                    <div className='p-d-fle p-ai-center p-jc-between p-w-100'>
                        <div>
                            <Tooltip className='p-m-0' target=".custom-choose-btn" content="Choose" position="bottom" />
                        </div>
                        <div>
                            <Tooltip className='p-m-0' target=".custom-upload-btn" content="Upload" position="bottom" />
                        </div>
                        <div>
                            <Tooltip className='p-m-0' target=".custom-cancel-btn" content="Clear" position="bottom" />
                        </div>
                        <FileUpload ref={fileUploadRef} name="file" accept=".xlsx" multiple={false} customUpload={true} uploadHandler={onTemplateUpload} headerTemplate={headerTemplate} itemTemplate={itemTemplate} emptyTemplate={emptyTemplate} chooseOptions={chooseOptions} uploadOptions={uploadOptions} cancelOptions={cancelOptions} />
                    </div>
                </div>
            </Dialog>
        </div>
    );
}

export default TeacherMaster;
